import { all } from "redux-saga/effects";

import productsOffers from "@/modules/Offers/sagas/productsOffers";
import banners from "@/modules/Settings/sagas/banners";
import businessUnits from "@/modules/Settings/sagas/businessUnits";
import carriers from "@/modules/Settings/sagas/carriers";
import distributionCenters from "@/modules/Settings/sagas/distributionCenters";
import modelsGroups from "@/modules/Settings/sagas/modelsGroups";
import offers from "@/modules/Settings/sagas/offers";
import plans from "@/modules/Settings/sagas/plans";
import pricingGroups from "@/modules/Settings/sagas/pricingGroups";
import products from "@/modules/Settings/sagas/products";
import roles from "@/modules/Settings/sagas/roles";
import services from "@/modules/Settings/sagas/services";
import servicesCategories from "@/modules/Settings/sagas/servicesCategories";
import shippingsGroups from "@/modules/Settings/sagas/shippingsGroups";
import shippingsType from "@/modules/Settings/sagas/shippingsType";
import users from "@/modules/Settings/sagas/users";
import profile from "@/modules/User/sagas/profile";

export default function* rootSaga() {
  return yield all([
    profile,
    businessUnits,
    carriers,
    plans,
    users,
    shippingsType,
    shippingsGroups,
    modelsGroups,
    distributionCenters,
    products,
    banners,
    pricingGroups,
    services,
    servicesCategories,
    roles,
    offers,
    productsOffers
  ]);
}
